/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompanySearchDto } from './CompanySearchDto';
import {
    CompanySearchDtoFromJSON,
    CompanySearchDtoFromJSONTyped,
    CompanySearchDtoToJSON,
    CompanySearchDtoToJSONTyped,
} from './CompanySearchDto';
import type { OrderSearchDto } from './OrderSearchDto';
import {
    OrderSearchDtoFromJSON,
    OrderSearchDtoFromJSONTyped,
    OrderSearchDtoToJSON,
    OrderSearchDtoToJSONTyped,
} from './OrderSearchDto';
import type { SearchPagedResponseDtoTotals } from './SearchPagedResponseDtoTotals';
import {
    SearchPagedResponseDtoTotalsFromJSON,
    SearchPagedResponseDtoTotalsFromJSONTyped,
    SearchPagedResponseDtoTotalsToJSON,
    SearchPagedResponseDtoTotalsToJSONTyped,
} from './SearchPagedResponseDtoTotals';
import type { InvoiceSearchDto } from './InvoiceSearchDto';
import {
    InvoiceSearchDtoFromJSON,
    InvoiceSearchDtoFromJSONTyped,
    InvoiceSearchDtoToJSON,
    InvoiceSearchDtoToJSONTyped,
} from './InvoiceSearchDto';
import type { StringOrderSearchDtoListKeyValuePair } from './StringOrderSearchDtoListKeyValuePair';
import {
    StringOrderSearchDtoListKeyValuePairFromJSON,
    StringOrderSearchDtoListKeyValuePairFromJSONTyped,
    StringOrderSearchDtoListKeyValuePairToJSON,
    StringOrderSearchDtoListKeyValuePairToJSONTyped,
} from './StringOrderSearchDtoListKeyValuePair';

/**
 * 
 * @export
 * @interface SearchResultDto
 */
export interface SearchResultDto {
    /**
     * 
     * @type {Array<CompanySearchDto>}
     * @memberof SearchResultDto
     */
    companies: Array<CompanySearchDto> | null;
    /**
     * 
     * @type {Array<OrderSearchDto>}
     * @memberof SearchResultDto
     */
    orders: Array<OrderSearchDto> | null;
    /**
     * 
     * @type {Array<StringOrderSearchDtoListKeyValuePair>}
     * @memberof SearchResultDto
     */
    matchedCompanyOrders: Array<StringOrderSearchDtoListKeyValuePair> | null;
    /**
     * 
     * @type {Array<InvoiceSearchDto>}
     * @memberof SearchResultDto
     */
    invoices: Array<InvoiceSearchDto> | null;
    /**
     * 
     * @type {SearchPagedResponseDtoTotals}
     * @memberof SearchResultDto
     */
    totals: SearchPagedResponseDtoTotals | null;
}

/**
 * Check if a given object implements the SearchResultDto interface.
 */
export function instanceOfSearchResultDto(value: object): value is SearchResultDto {
    if (!('companies' in value) || value['companies'] === undefined) return false;
    if (!('orders' in value) || value['orders'] === undefined) return false;
    if (!('matchedCompanyOrders' in value) || value['matchedCompanyOrders'] === undefined) return false;
    if (!('invoices' in value) || value['invoices'] === undefined) return false;
    if (!('totals' in value) || value['totals'] === undefined) return false;
    return true;
}

export function SearchResultDtoFromJSON(json: any): SearchResultDto {
    return SearchResultDtoFromJSONTyped(json, false);
}

export function SearchResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchResultDto {
    if (json == null) {
        return json;
    }
    return {
        
        'companies': (json['companies'] == null ? null : (json['companies'] as Array<any>).map(CompanySearchDtoFromJSON)),
        'orders': (json['orders'] == null ? null : (json['orders'] as Array<any>).map(OrderSearchDtoFromJSON)),
        'matchedCompanyOrders': (json['matchedCompanyOrders'] == null ? null : (json['matchedCompanyOrders'] as Array<any>).map(StringOrderSearchDtoListKeyValuePairFromJSON)),
        'invoices': (json['invoices'] == null ? null : (json['invoices'] as Array<any>).map(InvoiceSearchDtoFromJSON)),
        'totals': SearchPagedResponseDtoTotalsFromJSON(json['totals']),
    };
}

export function SearchResultDtoToJSON(json: any): SearchResultDto {
    return SearchResultDtoToJSONTyped(json, false);
}

export function SearchResultDtoToJSONTyped(value?: SearchResultDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companies': (value['companies'] == null ? null : (value['companies'] as Array<any>).map(CompanySearchDtoToJSON)),
        'orders': (value['orders'] == null ? null : (value['orders'] as Array<any>).map(OrderSearchDtoToJSON)),
        'matchedCompanyOrders': (value['matchedCompanyOrders'] == null ? null : (value['matchedCompanyOrders'] as Array<any>).map(StringOrderSearchDtoListKeyValuePairToJSON)),
        'invoices': (value['invoices'] == null ? null : (value['invoices'] as Array<any>).map(InvoiceSearchDtoToJSON)),
        'totals': SearchPagedResponseDtoTotalsToJSON(value['totals']),
    };
}

